import type { VoiceAgentConfig } from '@/lib/voice/agent-config'

export type VoiceScheduledSendToolName = 'send_email' | 'send_whatsapp'

/** A saved destination is required before a Voice Agent can expose either tool. */
export function getVoiceScheduledSendSetupMessage(
  config: VoiceAgentConfig | null | undefined,
  toolName: VoiceScheduledSendToolName,
): string | null {
  const settings = config?.ai_tools?.tool_settings?.[toolName]

  switch (toolName) {
    case 'send_email':
      return hasText(settings?.email_agent_id) && hasText(settings?.inbox_id)
        ? null
        : 'Choose an Email Agent and sending mailbox, then save email scheduling before enabling this tool.'
    case 'send_whatsapp':
      return hasText(settings?.message_agent_id)
        && hasText(settings?.channel_id)
        && hasText(settings?.template_name)
        && hasText(settings?.template_language)
        ? null
        : 'Choose a Messaging Agent, WhatsApp channel, and approved template, then save WhatsApp scheduling before enabling this tool.'
  }
}

function hasText(value: unknown): boolean {
  return typeof value === 'string' && value.trim().length > 0
}
